import {
  GETFEEREPORTLIST_SUCCESS,
  GETFEEREPORTLIST_FAILED,
  RESET_GETFEEREPORTLIST,
  LOADING_GETFEEREPORTLIST,
  NETWORK_ERROR_GETFEEREPORTLIST,
} from "../types/index";

const initialState = {
  isLoading: false,
  success: false,
  network: false,
  failed: false,
  data: {},
  message: "",
  networkError: "",
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_GETFEEREPORTLIST:
      return {
        ...state,
        isLoading: true,
        success: false,
        failed: false,
        network: false,
        data: {},
        message: "",
        networkError: "",
      };
    case GETFEEREPORTLIST_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: true,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case GETFEEREPORTLIST_SUCCESS:
      return {
        ...state,
        isLoading: false,
        success: true,
        failed: false,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case NETWORK_ERROR_GETFEEREPORTLIST:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: false,
        network: true,
        data: {},
        message: "",
        networkError: "",
      };
    case RESET_GETFEEREPORTLIST:
      return (state = initialState);
    default:
      return state;
  }
};
